import { IContextMenuPosition } from '@/components/context-menu';

export function getPositionFromMouseEvent(event: google.maps.MapMouseEvent): IContextMenuPosition {
  const domEvent = event.domEvent as MouseEvent;
  return {
    x: domEvent.clientX,
    y: domEvent.clientY
  };
}
